import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HeaderContainer, Header, Button } from 'carbon-components-react';
import { NewTab16 } from '@carbon/icons-react';
import { TopHeader } from 'components';
import StickyTopHeaderButton from 'components/StickyTopHeaderButton';
import { LeftHandSideNav, LeftHandSideRail } from '..';
import { GlobalToastAlerts, Announcements } from 'components';
import { BaseMapSwitcherPanel } from 'components/BaseMapSwitcher';
import { setHeaderPanelExpand } from 'redux/app/actions';
import { selectHeaderPanelExpand } from 'redux/app/selectors';
import { selectIsFromSwxLocate } from 'redux/session/selectors';
import { ReactComponent as LogoBYDABigAlternate } from 'assets/images/byda/ui-custom-logos-logo-wr.svg';

export interface HeaderProps {
  enableHeaderGlobalBar: boolean;
  stickyTopHeaderObj?: object;
  sideRailButtons?: object;
  sideRailExpandableMenu?: object;
  showAlternateHeaderBar?: boolean;
  referralPage?: any;
}
/**
 * MAIN HEADER CONTAINER
 */
export const MainHeaderContainer: React.FC<HeaderProps & any> = React.memo(
  (props: any) => {
    const {
      enableHeaderGlobalBar,
      stickyTopHeaderObj,
      sideRailButtons,
      showAlternateHeaderBar,
      referralPage
    } = props;
    const [isSideNavExpanded, setIsSideNavExpanded] = useState<boolean>(false);

    const dispatch = useDispatch();
    const headerPanelExpand: any = useSelector(selectHeaderPanelExpand);
    const isFromSwxLocate = useSelector(selectIsFromSwxLocate);
    const hamburgerMenuHandler = useCallback(() => {
      if (!isSideNavExpanded) {
        dispatch(setHeaderPanelExpand({ isOpen: false }));
      }
      setIsSideNavExpanded(!isSideNavExpanded);
    }, [isSideNavExpanded, dispatch]);

    const handleOpenNewTabClick = () => {
      if (referralPage?.from) {
        const url = referralPage?.from;
        const win = window.open(url, '_blank');
        win && win.focus();
      }
    };

    useEffect(() => {
      if (headerPanelExpand?.isOpen) {
        setIsSideNavExpanded(false);
      }
    }, [headerPanelExpand]);

    return (
      <>
        {!isFromSwxLocate && (
          <HeaderContainer
            render={() => (
              <Header
                aria-label="global header"
                className={`${showAlternateHeaderBar ? 'hide-header-bar' : ''}`}
              >
                {props.children}
                {!showAlternateHeaderBar && (
                  <TopHeader
                    enableHeaderGlobalBar={
                      enableHeaderGlobalBar ? enableHeaderGlobalBar : false
                    }
                    isStickyTopHeaderButton={true}
                    hamburgerMenuHandler={hamburgerMenuHandler}
                    isSideNavExpanded={isSideNavExpanded}
                  >
                    {stickyTopHeaderObj && (
                      <StickyTopHeaderButton
                        stickyTopHeaderObj={stickyTopHeaderObj}
                      />
                    )}
                    {sideRailButtons && (
                      <div className="map-action--buttons  bx--col-sm-0  bx--col-md-0">
                        <LeftHandSideRail sideRailButtons={sideRailButtons} />
                      </div>
                    )}
                  </TopHeader>
                )}
                {showAlternateHeaderBar && (
                  <div className="alternate-header">
                    <div className="alternate-header-logo">
                      <LogoBYDABigAlternate />
                    </div>
                    <div>
                      <Button
                        onClick={handleOpenNewTabClick}
                        kind={'secondary'}
                        renderIcon={NewTab16}
                        className="alternate-header-button"
                        disabled={referralPage?.from === undefined}
                      >
                        Open in new tab
                      </Button>
                    </div>
                  </div>
                )}
                {!isFromSwxLocate && (
                  <LeftHandSideNav
                    isSideNavExpanded={isSideNavExpanded}
                    setIsSideNavExpanded={setIsSideNavExpanded}
                  />
                )}

                <BaseMapSwitcherPanel />
                <GlobalToastAlerts />
                <Announcements />
              </Header>
            )}
          />
        )}
      </>
    );
  }
);
